import {
  IContractTemplateTreeItemForm,
  IDistributionResponse,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { connectTemplateTreeItems } from '../templateQueryItemsConnector';

export const physicalDistributionTemplateQueryToForm = (
  distribution: IDistributionResponse,
  lowestAvailableId?: string,
  disabledSelection = false,
  disabledRemove = false
): IContractTemplateTreeItemForm[] => {
  const [physicalDistribution] = connectTemplateTreeItems(
    {
      physicalDistribution: { ...distribution, position: 0 },
    },
    lowestAvailableId ?? '1'
  );

  const physicalDistributionForm: IContractTemplateTreeItemForm = {
    ...physicalDistribution,
    disabledSelection: disabledSelection,
    disabledRemove: disabledRemove,
  };

  return contractTemplateUtil.distribution.initialValues(
    TEMPLATE_TYPE.physicalDistribution,
    [physicalDistributionForm]
  );
};
